import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { captureError } from "@/lib/utils";

export function useConcepts() {
  return useQuery({
    queryKey: ["concepts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("concepts")
        .select("*")
        .order("label");

      if (error) {
        captureError(error, { location: "useConcepts" });
        throw error;
      }
      return data;
    },
  });
}

export function useConceptLinks() {
  return useQuery({
    queryKey: ["concept-links"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("concept_links")
        .select("*");

      if (error) {
        captureError(error, { location: "useConcepts" });
        throw error;
      }
      return data;
    },
  });
}

export function useConcept(slug: string | undefined) {
  return useQuery({
    queryKey: ["concept", slug],
    queryFn: async () => {
      if (!slug) return null;

      const { data, error } = await supabase
        .from("concepts")
        .select("*")
        .eq("slug", slug)
        .single();

      if (error) {
        captureError(error, { location: "useConcepts" });
        throw error;
      }
      return data;
    },
    enabled: !!slug,
  });
}
